//! TODO:2023: make 1 function for both clearObject and clearObjectEmptyFields
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';

import { isEmptyField } from './validationUtils';

const CLEANER_VALUES = [null, undefined, ''];

const clearObject = (value, _CLEANER_VALUES = CLEANER_VALUES) => {
  const cleanedObj = { ...value };
  Object.keys(cleanedObj).forEach(key => {
    if (isObject(cleanedObj[key])) {
      const newCleanObject = clearObject(cleanedObj[key], _CLEANER_VALUES);
      if (isEmpty(newCleanObject)) {
        delete cleanedObj[key];
      } else {
        cleanedObj[key] = newCleanObject;
      }
    }
    if (_CLEANER_VALUES.includes(cleanedObj[key])) {
      delete cleanedObj[key];
    }
  });

  return cleanedObj;
};

const cleanObjectEmptyFields = obj => {
  for (const propName in obj) {
    const value = obj[propName];
    if (isObject(value)) {
      if (Object.keys(value).length) {
        cleanObjectEmptyFields(value);
      } else {
        delete obj[propName];
      }
    }
    if (isEmptyField(value)) {
      delete obj[propName];
    }
  }

  return obj;
};

const defaultOptions = {
  isEmpty: true,
  isEmptyArray: true,
  isNull: true,
  isUndefined: true,
  isNaN: true,
  isBoolean: false
};

const getCleanObject = (object, argOptions = defaultOptions) => {
  const options = { ...defaultOptions, ...argOptions };

  for (const propName in object) {
    if (isObject(object[propName])) {
      getCleanObject(object[propName]);
    }

    if (!options.isBoolean && typeof object[propName] === 'boolean') {
      continue;
    }

    if (options.isEmpty && !isNumber(object[propName]) && isEmpty(object[propName])) {
      if (!options.isEmptyArray && Array.isArray(object[propName])) {
        continue;
      }
      delete object[propName];
    }

    if (options.isNull && object[propName] === null) {
      delete object[propName];
    }

    if (options.isUndefined && object[propName] === undefined) {
      delete object[propName];
    }

    if (options.isNaN && typeof object[propName] === 'number' && Number.isNaN(object[propName])) {
      delete object[propName];
    }
  }

  return object;
};

export { cleanObjectEmptyFields, clearObject, getCleanObject };
